import { render, staticRenderFns } from "./videoAutomaticLabel.vue?vue&type=template&id=2c862b3a&scoped=true&"
import script from "./videoAutomaticLabel.vue?vue&type=script&lang=js&"
export * from "./videoAutomaticLabel.vue?vue&type=script&lang=js&"
import style0 from "./videoAutomaticLabel.vue?vue&type=style&index=0&id=2c862b3a&prod&lang=scss&scoped=true&"
import style1 from "./videoAutomaticLabel.vue?vue&type=style&index=1&id=2c862b3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c862b3a",
  null
  
)

export default component.exports